// A3.19/A3.38 — ichki xodim izohlari adapter. Module-local. Append-only:
// izoh qo'shiladi va ko'riladi, o'chirilmaydi/o'zgartirilmaydi (hisobdorlik).
import { api } from '@/lib/api'

export interface UserNote {
  id: number
  admin_id?: number | null
  author?: string | null // admin username
  note: string
  created_at: number
}

export async function fetchUserNotes(userId: number, limit = 100): Promise<UserNote[]> {
  const r = await api.get<{ items?: UserNote[] }>(`/admin/users/${userId}/notes`, { query: { limit } })
  return r.items ?? []
}

export async function addUserNote(userId: number, note: string): Promise<number> {
  const r = await api.post<{ id: number }>(`/admin/users/${userId}/notes`, { note })
  return r.id
}
